import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import { Column, Layout, Row, Rows, Section } from '@/components/layout'
import OurValues from '@/components/sections/OurValues'
import { Text } from '@/components/common'
import heartbeatImg from '@/assets/careers/heartbeat.svg'
import planeDepartureImg from '@/assets/careers/plane-departure.svg'
import clockImg from '@/assets/careers/clock.svg'
import busImg from '@/assets/careers/bus.svg'
import dollarSignImg from '@/assets/careers/dollar-sign.svg'
import buildingImg from '@/assets/careers/building.svg'

import styles from './careers.module.scss'

const pageId = 'careers'

const getMessageId = id => `pages.${pageId}.${id}`

const benefits = [
  { name: 'medical', icon: 'heartbeat', img: heartbeatImg },
  { name: 'pto', icon: 'plane-departure', img: planeDepartureImg },
  { name: 'holidays', icon: 'clock', img: clockImg },
  { name: 'transit', icon: 'bus', img: busImg },
  { name: 'salary', icon: 'dollar-sign', img: dollarSignImg },
  { name: 'environment', icon: 'building', img: buildingImg },
]

const BenefitColumn = ({ icon, img, name }) => (
  <Column className={styles.benefitColumn} size={33}>
    <Image
      alt={icon}
      className={styles.benefitImg}
      src={img}
    />
    <Rows gap={4}>
      <Text.H3 className={styles.benefitHeader} messageId={getMessageId(`whatWeOffer.${name}.name`)} />
      <Text.P messageId={getMessageId(`whatWeOffer.${name}.p`)} />
    </Rows>
  </Column>
)

BenefitColumn.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
}

export default function Careers() {
  return (
    <Layout.Content>
      <Section bgBlob>
        <Rows center maxWidth={800} textCenter>
          <Text.H1 messageId={getMessageId('header.title')} />
          <Text.P messageId={getMessageId('header.subtitle')} />
        </Rows>
      </Section>
      <OurValues />
      <Section>
        <Row>
          <Column center textCenter>
            <Text.H2 messageId={getMessageId('whatWeOffer.title')} />
          </Column>
        </Row>
        <Row className={styles.benefits} gap={2} wrap>
          {benefits.map((benefit) => (
            <BenefitColumn {...benefit} />
          ))}
        </Row>
      </Section>
      <Section bgSecondary>
        <Row>
          <Column center textCenter>
            <Text.H2 messageId={getMessageId('openings.title')} />
          </Column>
        </Row>
        <Row>
          <Column justifyCenter size={50}>
            <Text.P center messageId={getMessageId('openings.noOpenings')} />
          </Column>
        </Row>
      </Section>
    </Layout.Content>
  )
}

Careers.layoutProps = {
  pageId,
}
